import React from 'react';
import 'twin.macro';
import useSequencesFolders from 'queries/sequences/useSequencesFolders';
import { Navigate, useParams } from 'react-router-dom';
import { FolderContent } from './FolderContent';
import { findFolderNodeWithAncestors } from 'containers/Sequences/findFolderNodeWithAncestors';
import { useUpdateFolder } from 'containers/Sequences/queries/useUpdateFolder';
import ScreenSpinner from 'components/Spinner/ScreenSpinner';

export function FolderContentWrapper() {
  const { data, isInitialLoading, isRefetching } = useSequencesFolders();
  const params = useParams<{
    folderId: string;
  }>();
  const updateFolder = useUpdateFolder();
  const folderId = params.folderId as string;

  if (isInitialLoading) {
    return <ScreenSpinner />;
  }

  const matchingFolder = findFolderNodeWithAncestors(data || [], folderId);
  if ((!matchingFolder || !matchingFolder?.folder) && isRefetching) {
    return <ScreenSpinner />;
  }

  if (!matchingFolder || !matchingFolder?.folder) {
    return <Navigate to="/sequences" />;
  }
  return (
    <FolderContent
      folder={matchingFolder?.folder}
      ancestors={matchingFolder?.ancestors || []}
      onChange={v =>
        updateFolder({
          name: v.title,
          id: v.id,
        })
      }
    />
  );
}
